import AppShellNav from '../shell/AppShellNav';

export default function AppsNav() {
  return <AppShellNav active="tools" />;
}
